import { Navigate, useNavigate } from "react-router-dom";
import { memo } from "react";
import { motion } from "framer-motion";
import backarrow from "../assets/icon/arrow-right.svg";
import {
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
  FaCalendarAlt,
  FaChartBar,
} from "react-icons/fa";

const AnimatedBackground = memo(() => {
  const icons = [
    FaBook,
    FaBookOpen,
    FaRegListAlt,
    FaDatabase,
    FaUserGraduate,
    FaChalkboardTeacher,
    FaCalculator,
    FaChartLine,
    FaCoins,
    FaPenFancy,
    FaRegFileAlt,
    FaPencilAlt,
  ];

  const rows = 5;
  const cols = 11;
  const iconArray = [];

  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      const Icon = icons[Math.floor(Math.random() * icons.length)];
      iconArray.push({
        Icon,
        size: 18 + Math.random() * 20,
        top: (i / rows) * 100 + Math.random() * 5,
        left: (j / cols) * 100 + Math.random() * 5,
        duration: 15 + Math.random() * 10,
        opacity: 0.15 + Math.random() * 0.25,
        xOffset: Math.random() * 10 - 5,
        yOffset: Math.random() * 10 - 5,
      });
    }
  }

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {iconArray.map((item, index) => (
        <motion.div
          key={index}
          className="absolute text-white/50"
          style={{
            top: `${item.top}%`,
            left: `${item.left}%`,
            opacity: item.opacity,
          }}
          initial={{ scale: 0.5 }}
          animate={{
            x: [0, item.xOffset, 0],
            y: [0, item.yOffset, 0],
            scale: [0.5, 1, 0.5],
          }}
          transition={{
            duration: item.duration,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <item.Icon size={item.size} />
        </motion.div>
      ))}
    </div>
  );
});

const FinancialBalanceHome = () => {
  const navigate = useNavigate();

  if (!localStorage.getItem("token")) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="relative min-h-screen w-full bg-gray-800 flex items-center justify-center p-4">
      <AnimatedBackground />

      {/* کارت اصلی  */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl w-full max-w-xl mx-auto border border-white/30 overflow-hidden"
      >
        {/* هدر */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200">
          <img
            src={backarrow}
            alt="بازگشت"
            className="w-8 h-8 cursor-pointer hover:scale-110 transition-transform"
            onClick={() => navigate(-1)}
          />
          <h2 className="text-2xl font-bold text-gray-800">گزارش‌های مالی</h2>
          <div className="w-8" />
        </div>

        <div className="p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* گزارش ماهیانه */}
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => navigate("/Mainpage/FinancialBalance/Monthly")}
              className="h-48 bg-gradient-to-br from-[#215666] to-[#1c3073] text-white rounded-2xl shadow-xl flex flex-col items-center justify-center gap-4 transition-all duration-300"
            >
              <FaCalendarAlt className="text-5xl" />
              <span className="text-xl font-iranSansNormal">گزارش ماهیانه</span>
            </motion.button>

            {/* گزارش سالیانه */}
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => navigate("/Mainpage/FinancialBalance/Yearly")}
              className="h-48 bg-gradient-to-br from-[#4BC0C0] to-[#2aa6a6] text-white rounded-2xl shadow-xl flex flex-col items-center justify-center gap-4 transition-all duration-300"
            >
              <FaChartBar className="text-5xl" />
              <span className="text-xl font-iranSansNormal">گزارش سالیانه</span>
            </motion.button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default FinancialBalanceHome;
